import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Arrow, Box, Diagram} from "../shared/Diagram"

export default function MonolithVsMicroservices() {
    return (
        <TopicLayout
            title="Monolith vs. microservices"
            intro="Whether the system ships and runs as one deployable unit with local function calls between its parts, or as several independently deployable services that talk to each other over the network."
            diagram={
                <Diagram viewBox="0 0 560 200">
                    <text x={140} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Monolith — one deployable</text>
                    <rect x={20} y={28} width={240} height={132} rx={6}
                          style={{fill: 'none', stroke: 'var(--header-background)', strokeWidth: 1.5, strokeDasharray: '5 4'}}/>
                    <Box x={45} y={40} width={190} height={32} label="Orders module"/>
                    <Box x={45} y={82} width={190} height={32} label="Users module"/>
                    <Box x={45} y={124} width={190} height={32} label="Billing module"/>

                    <line x1={300} y1={10} x2={300} y2={190} stroke="var(--header-background)" opacity={0.25}/>

                    <text x={430} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Microservices — independent deployables</text>
                    <Box x={330} y={40} width={100} height={40} label="Orders" accent/>
                    <Box x={330} y={140} width={100} height={40} label="Users" accent/>
                    <Box x={460} y={90} width={100} height={40} label="Billing" accent/>
                    <Arrow x1={430} y1={68} x2={460} y2={100} label="API call"/>
                    <Arrow x1={430} y1={152} x2={460} y2={122}/>
                </Diagram>
            }
            useWhen={[
                'Monolith or modular monolith: one team owns the product, domain boundaries are still moving, or independent deployment is not yet a bottleneck.',
                'Microservices: multiple teams need independent deployment or one bounded component has genuinely different scaling or isolation requirements.'
            ]}
            tradeOff="Microservices can improve team autonomy and independent scaling, but replace function calls with networks and add contract versioning, observability, service discovery, deployment and cross-service data consistency. A modular monolith keeps local calls and transactions while preserving boundaries that can be split later."
            ruleOfThumb="Split around stable domain and team ownership boundaries in response to measured organizational or scaling pain, not because smaller repositories look cleaner."
        />
    )
}
